/**
 * Webinar Info
 */
import { Component, registerComponent } from 'js/component.js';
import { DateTime } from 'luxon';

const componentName = 'webinar-info';

class WebinarInfo extends Component {

    /** Component setup */
    elements = {
        webinarStart: this.element.querySelector(`.${componentName}__item.startDate`)
    };

    /** Initialize component */
    init() {
        // Determine webinar status (Upcoming or On-Demand)
        const siteTimezone = document.querySelector('html').getAttribute('data-timezone');
        const nowInSiteZone = DateTime.now().setZone(siteTimezone);
        const webinarOnDemand = this.elements.webinarStart.dataset.ondemandEventTime;
        let itemsToHide = null;

        if (nowInSiteZone.toString() > webinarOnDemand.toString()) { // On-Demand date has passed
            this.elements.webinarStart.setAttribute('data-webinar-status', 'on-demand');
            document.querySelector('.hero-banner__text-container').setAttribute('data-webinar-status', 'on-demand');
            itemsToHide = this.element.querySelectorAll('.is-future');
        } else {
            itemsToHide = this.element.querySelectorAll('.is-past');
        }
        for (let i = 0; i < itemsToHide.length; i += 1) {
            itemsToHide[i].style.display = ('none');
        }
    }
}

registerComponent(`.${componentName}`, WebinarInfo);
